// extracted by mini-css-extract-plugin
module.exports = {"content_placeholder":"_7de522c","placeHolderShimmer":"_18bef96","display_line":"_726f127"};